import { WidgetTourConfig } from '../models'

export const compareWidgetTours = (first: WidgetTourConfig, second: WidgetTourConfig): number => {
  const priorityDifference = (second.priority ?? 0) - (first.priority ?? 0)

  return priorityDifference || first.id.localeCompare(second.id)
}
